export default __webpack_public_path__ + "static/media/c001-ngo-3.273444f0.jpg";